// Sent with every CRM login so the Account Sessions page can tell devices apart.
// - deviceId: random ID this browser keeps in its own storage (same browser = same ID).
//   Logout only removes token/userData/sidebarFrom, so the ID stays.
// - clientInfo: Chrome/Edge Client Hints (Windows 10 vs 11, Android version and phone model).
//   Firefox/Safari don't have them; the backend then uses the user agent only.

const DEVICE_ID_KEY = 'crmDeviceId';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const newUuid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Older browsers / non-secure pages
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : (r % 4) + 8).toString(16);
  });
};

export const getDeviceId = () => {
  try {
    const saved = localStorage.getItem(DEVICE_ID_KEY);
    if (saved && UUID_RE.test(saved)) return saved;
    const id = newUuid();
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return ''; // storage blocked: login still works, just without a device ID
  }
};

// Never waits more than 500 ms, never throws.
export const getClientInfo = async () => {
  try {
    const uaData = typeof navigator !== 'undefined' ? navigator.userAgentData : null;
    if (!uaData || typeof uaData.getHighEntropyValues !== 'function') return {};
    const hints = await Promise.race([
      uaData.getHighEntropyValues(['platformVersion', 'model']),
      new Promise((resolve) => setTimeout(() => resolve(null), 500)),
    ]);
    if (!hints) return {};
    return {
      platform: hints.platform || uaData.platform || '',
      platformVersion: hints.platformVersion || '',
      model: hints.model || '',
    };
  } catch {
    return {};
  }
};

// { deviceId, clientInfo } to add to a login request body.
export const getLoginDeviceFields = async () => ({
  deviceId: getDeviceId(),
  clientInfo: await getClientInfo(),
});
